export default "__VITE_ASSET__Rpxk4Fvz__"